import React from 'react'

import { Container, ContentHeader } from 'components'

import { Box, CircularProgress } from '@material-ui/core'
import TaxInvoicesForm from './components/TaxInvoicesForm'
import useFetch from 'hooks/useFetch'
import * as service from 'service'

const TaxInvoicesEdit = ({ match }) => {
  const { taxInvoiceId } = match.params
  const [pageLoader, setPageLoader] = React.useState(false)

  const { response, isLoading } = useFetch(service.recurrence.taxInvoices.get, {
    taxInvoiceId,
  })

  return (
    <Container>
      <ContentHeader title="Nota Fiscal" subtitle="Editar" />
      {pageLoader || isLoading ? (
        <Box display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      ) : (
        <TaxInvoicesForm
          taxInvoiceId={taxInvoiceId}
          taxInvoice={response.data.serviceTaxInvoice}
          loadingRequest={setPageLoader}
        ></TaxInvoicesForm>
      )}
    </Container>
  )
}

export default TaxInvoicesEdit
